import { createContext, useContext, useEffect, useState, type ReactNode } from "react"

interface NavContextType {
  showNav: boolean
  setShowNav: (show: boolean) => void
}

const NavContext = createContext<NavContextType | undefined>(undefined)

export const NavProvider = ({ children }: { children: ReactNode }) => {
  const [showNav, setShowNav] = useState(true)

  return <NavContext.Provider value={{ showNav, setShowNav }}>{children}</NavContext.Provider>
}

interface UseNavOptions {
  show?: boolean
}

export const useNav = (options?: UseNavOptions) => {
  const context = useContext(NavContext)
  if (!context) {
    throw new Error("useNav must be used within a NavProvider")
  }

  const { setShowNav } = context
  const show = options?.show ?? true

  useEffect(() => {
    if (!show) {
      setShowNav(false)
      return () => setShowNav(true)
    }
  }, [show, setShowNav])

  return context
}
